import React, { ForwardRefRenderFunction, InputHTMLAttributes } from 'react';

/**
 * Note that for text inputs, you must add the type="text" attribute for these styles to take effect.
 * Checkout more details on https://github.com/tailwindlabs/tailwindcss-forms
 *
 */
interface IProps extends InputHTMLAttributes<HTMLInputElement> {
  /** Forwarding Ref: https://reactjs.org/docs/forwarding-refs.html  */
  ref: string;
}

const FormInput: ForwardRefRenderFunction<HTMLInputElement, IProps> = (
  { ...props },
  ref,
) => {
  return <input {...props} ref={ref} />;
};

export const BaseInput = React.forwardRef(FormInput);
